import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import EmptyAvatar from '../../assets/images/emptyAvatar.png';
import Text from '../Text/Text';
import { MEDIA_URL } from '../../constants/api';
import routes from '../../router/routes';

const UserCardSmall = ({ user }) => {
  const {
    avatar, name, last_name: lastName, email, id
  } = user;
  const { users: usersOnline } = useSelector((state) => state?.userOnlineList);
  const navigate = useNavigate();
  const isUserOnline = usersOnline?.find((userOnline) => userOnline.id === `${id}`);
  return (
    <div onClick={() => navigate(`${routes.USERS}/${id}`)} role="presentation">
      <div className="flex flex-row items-center cursor-pointer">
        <div className="flex mr-[8px] relative">
          {isUserOnline && (
            <div className="w-[10px] h-[10px] rounded-full bg-[green] right-[-4px] top-[40px] absolute" />
          )}
          {avatar
            ? <img src={`${MEDIA_URL}/${avatar}`} alt="user avatar img" className="w-[50px] h-[50px] rounded-full" />
            : <img src={EmptyAvatar} alt="user avatar img" className="w-[50px] h-[50px] rounded-full" />}
        </div>
        <div>
          <Text text={`${name || ''} ${lastName || ''}`} textStyle="text-[14px] mb-[3px] font-normal" />
          <Text text={email} muted textStyle="text-[14px] font-normal text-romanSilver" />
        </div>
      </div>
    </div>

  );
};

UserCardSmall.propTypes = {
  user: PropTypes.shape({
    avatar: PropTypes.string,
    name: PropTypes.string,
    last_name: PropTypes.string,
    email: PropTypes.string,
    login: PropTypes.string,
    id: PropTypes.number,
    online: PropTypes.number,
  })
};

UserCardSmall.defaultProps = {
  user: {}
};

export default UserCardSmall;
